/**
 * @module M/plugin/StyleTools
 */
import 'assets/css/styletools';
import 'assets/css/fonts';
import PointStyle from './pointStyle';
import LegendStyle from './legendStyle';
import LineStringStyle from './lineStringStyle';
import PolygonStyle from './polygonStyle';
import TextStyle from './textStyle';

export default class StyleTools extends M.Plugin {
  /**
   * @classdesc
   * Main facade plugin object. This class creates a plugin
   * object which has an implementation Object
   *
   * @constructor
   * @extends {M.Plugin}
   * @param {Object} impl implementation object
   * @api stable
   */
  constructor(features, map, plugin, legendCache) {
    super();
    /**
     * Facade of the map
     * @private
     * @type {M.Map}
     */
    this.map = null;
    this.features = features || [];
    if (features && features[0]) {
      this.geometry = features[0].getGeometry().getType();
    } else {
      this.geometry = null;
    }
    this.plugin = plugin;
    this.legendCache = legendCache || undefined;
    if (this.legendCache) {
      this.legendControlCache = new LegendStyle(this, this.legendCache);
    }
    this.panel = null;
    this.control = null;
    /**
     * Array of controls
     * @private
     * @type {Array<M.Control>}
     */
    this.controls_ = [];
    this.addTo(map);
  }

  /**
   * This function adds this plugin into the map
   *
   * @public
   * @function
   * @param {M.Map} map the map to add the plugin
   * @api stable
   */
  addTo(map) {
    this.map = map;
    // panel para agregar control - no obligatorio
    this.panel = new M.ui.Panel('panelStyleTools', {
      collapsible: false,
      position: M.ui.position.TL,
      className: 'm-tools-styleTools',
    });
    if (this.legendCache && this.geometry == null) {
      this.control = this.legendControlCache || new LegendStyle(this, this.legendCache);
    } else {
      if (this.geometry == 'Polygon' || this.geometry == 'MultiPolygon') {
        this.control = new PolygonStyle(this, this.features);
      } else if (this.geometry == 'LineString' || this.geometry == 'MultiLineString' || this.geometry == 'GeometryCollecion') {
        this.control = new LineStringStyle(this, this.features);
      } else if (this.features[0].getStyle().text_ !== null) {
        this.control = new TextStyle(this, this.features);
      } else {
        this.control = new PointStyle(this, this.features);
      }
    }
    this.panel.addControls([this.control]);
    map.addPanels(this.panel);
  }

  destroyControl() {
    if (this.features && this.features[0] && (this.features[0].getStyle().text_ !== null && this.features[0].getStyle().text_ !== undefined) && typeof this.control.setStyleWithoutBorder === 'function') {
      this.control.setStyleWithoutBorder();
    }

    this.plugin.square = null;
    this.plugin.slayer.getImpl().getOL3Layer().getSource().clear();
    document.getElementById('styleToolsHTML').remove();
    this.map.getMapImpl().removeControl(this.control);
    this.features = null;
    this.geometry = null;
    const elemArray = ['m-button-drawFeature', 'm-button-drawFeature2', 'm-button-drawFeature3', 'm-button-drawFeature5', 'm-button-pickfeature', 'm-button-addlegend'];
    elemArray.forEach((elemTag) => {
      const elem = document.getElementById(elemTag);
      if (elem !== null && elem.parentElement !== null && elem.parentElement.classList.contains('activated')) {
        elem.click();
      }
    });
  }

  changeElements(feature, plugin) {
    this.features = feature;
    this.geometry = feature[0].getGeometry().getType();
    this.plugin = plugin;
    if (document.getElementById('styleToolsHTML') != null) {
      document.getElementById('styleToolsHTML').remove();
    }
    this.map.getMapImpl().removeControl(this.control);
    if (this.geometry == 'Polygon' || this.geometry == 'MultiPolygon') {
      this.control = new PolygonStyle(this, this.features);
    } else if (this.geometry == 'LineString' || this.geometry == 'MultiLineString' || this.geometry == 'GeometryCollection') {
      this.control = new LineStringStyle(this, this.features);
    } else if (this.features[0].getStyle().text_ !== null) {
      this.control = new TextStyle(this, this.features);
    } else {
      this.control = new PointStyle(this, this.features);
    }
    this.panel.addControls([this.control]);
  }

  openLegendMenu(cache) {
    if (cache) {
      this.legendCache = cache;
    }
    if (document.getElementById('styleToolsHTML') != null) {
      document.getElementById('styleToolsHTML').remove();
    }
    this.map.getMapImpl().removeControl(this.control);
    if (this.legendCache) {
      this.legendControlCache = new LegendStyle(this, this.legendCache);
    } else {
      this.legendControlCache = new LegendStyle(this);
    }
    this.control = this.legendControlCache;
    this.panel.addControls([this.control]);
  }

  getLegendToSend(focus) { // If needed focus would be used for series
    if (this.legendControlCache) {
      return this.legendControlCache.getLegendToSend();
    }
    return undefined;
  }

  getLegendCache() {
    if (this.legendControlCache) {
      return this.legendControlCache.getAllParameters();
    }
    return undefined;
  }

  clearLegend() {
    this.legendCache = undefined;
    if (this.legendControlCache) {
      this.legendControlCache.destroy();
      this.legendControlCache = undefined;
    }
  }

  destroy() {
    this.panel.removeControls(this.panel.getControls());
    this.features = null;
    this.geometry = null;
    this.panel = null;
    this.controls_ = null;
    this.map = null;
  }
}
